export const BRAND_VOICE_ASSET_FIELD = {
  toneOfVoices: 'toneOfVoices',
  customModels: 'customModels',
  customFormulas: 'customFormulas',
  targetAudiences: 'targetAudiences',
  brandBriefs: 'brandBriefs',
  brandTerms: 'brandTerms',
};
